DialogController = App.loadClass 'core::Angular/DialogController'

class exports.BinInspectionsController extends DialogController
    constructor: (
        @scope,
        @transitions,
        @modalInstance,
        @service,
        @loading,
        bin,
        year
    ) ->
        super
        @scope.title = 'Bin Inspection'
        @scope.save = () =>
            promise = if @inspection.id? then @inspection.$update() else @inspection.$save()
            promise
            .then () =>
                @modalInstance.close()
            .catch (msg) =>
                errorMessages = []
                for property, errors of msg.data
                    for validationError in errors
                        errorMessages.push validationError
                if errorMessages.length
                    @setAlert
                        msg: 'Validation Errors'
                        type: 'error'
                    , errorMessages

        if bin.inspection?
            # Retrieve the pre-existing inspection record
            @inspection = bin.inspection
            if @inspection.other_debris
                @inspection.has_other_debris = true
        else
            # Create a new one if one didn't exist
            @inspection = new @service.BinInspection
                storage_locations_id: bin.id
                year: year
            bin.inspection = @inspection

        @concreteBaseConditions = [
            'Good'
            'Fair'
            'Poor'
        ]
        @generalConstructionOptions = [
            'Good'
            'Fair'
            'Poor'
        ]
        @lastPulledYears = [moment().year()..1955]

    unsetCleanliness: () =>
        if @inspection.is_clean
            @inspection.has_animal_waste = false
            @inspection.has_insect_activity = false
            @inspection.has_foreign_crops = false
            @inspection.has_other_debris = false
            @inspection.other_debris = null
